const u = up.util;
const HTML_CONTENT_TYPE = /^(text\/html|application\/xhtml\+xml) *(;|$)/i;
up.Response = class Response extends up.Record {
    keys() {
        return [
            'method',
            'url',
            'text',
            'status',
            'request',
            'xhr',
            'target',
            'title',
            'openLayer',
            'acceptLayer',
            'dismissLayer',
            'eventPlans',
            'context',
            'expireCache',
            'evictCache',
            'headers',
            'loadedAt',
            'fail',
        ];
    }
    defaults() {
        return {
            headers: {},
            loadedAt: new Date(),
        };
    }
    get ok() {
        var _a;
        return !u.evalOption((_a = this.fail) !== null && _a !== void 0 ? _a : up.network.config.fail, this);
    }
    get none() {
        return !this.text;
    }
    header(name) {
        var _a;
        return this.headers[name] || ((_a = this.xhr) === null || _a === void 0 ? void 0 : _a.getResponseHeader(name));
    }
    get varyHeaderNames() {
        let varyHeaderValue = this.header('Vary');
        return u.getSimpleTokens(varyHeaderValue, { separator: ',' });
    }
    get contentType() {
        return this.header('Content-Type');
    }
    isHTML() {
        return HTML_CONTENT_TYPE.test(this.contentType);
    }
    get cspInfo() {
        let policy = this.header('Content-Security-Policy') || this.header('Content-Security-Policy-Report-Only');
        return up.CSPInfo.fromHeader(policy);
    }
    get lastModified() {
        let header = this.header('Last-Modified');
        if (header) {
            return new Date(header);
        }
    }
    get etag() {
        return this.header('ETag');
    }
    get json() {
        return this.parsedJSON || (this.parsedJSON = JSON.parse(this.text));
    }
    get age() {
        let now = new Date();
        return now - this.loadedAt;
    }
    get expired() {
        return this.age > up.network.config.cacheExpireAge ||
            this.request.expired;
    }
    get description() {
        return `HTTP ${this.status} response to ${this.request.description}`;
    }
    get redirect() {
        return (this.url !== this.request.url) || (this.method !== this.request.method);
    }
    get redirectRequest() {
        if (!this.redirect)
            return;
        let finalRequest = u.variant(this.request, {
            method: this.method,
            url: this.url,
            cacheRoute: null,
        });
        up.cache.track(this.request, finalRequest, { force: true });
        return finalRequest;
    }
};
